import type { ReactNode } from 'react'

import { ErrorNotice } from '@krp/ui-kit'

import type { ShownError } from '../model/types'
import './schedule.css'

/**
 * Отказ целиком: заголовок, текст службы дословно, код и номер запроса, «Скопировать ошибку». Таймера нет: отказ уходит, когда
 * человек повторил действие или закрыл окно.
 */
export function ErrorBlock({ error }: { error: ShownError }) {
  return (
    <div className="sch-error">
      <ErrorNotice error={error.error} title={error.title} />
    </div>
  )
}

/** Текст только для диктора. */
export function SrOnly({ children }: { children: ReactNode }) {
  return <span className="sch-sr">{children}</span>
}
